import React, { useEffect, useState } from "react";
import { Loader } from "lucide-react";

interface ReinversionModalProps {
  isOpen: boolean;
  customerId: string;
  onClose: () => void;
}

const ReinversionModal = ({ isOpen, onClose, customerId }: ReinversionModalProps) => {
  const [isLoadingIframe, setIsLoadingIframe] = useState(true);

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleEsc);
      setIsLoadingIframe(true);
    }

    return () => window.removeEventListener("keydown", handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 overflow-y-auto"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="relative bg-white rounded-lg w-full max-w-4xl h-[85vh] flex flex-col overflow-hidden transition-all duration-300">
        <button
          onClick={onClose}
          className="absolute right-4 top-2 text-gray-400 hover:text-gray-500 z-20"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <div className="flex-grow relative">
          {isLoadingIframe && (
            <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-10">
              <Loader size={40} className="animate-spin text-blue-500" />
            </div>
          )}

          <iframe
            src={`https://editor.lisual.com/reinversion/${customerId}`}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="Reinversión"
            allow="clipboard-write"
            onLoad={() => setIsLoadingIframe(false)}
          />
        </div>

        <div className="px-6 py-4 border-t flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReinversionModal;
